import axios from "axios";

const baseURL = process.env.REACT_APP_BASE_URL;

export default async function initializeSession(){

    const existingToken = localStorage.getItem("sessionToken");
    if(existingToken){
        return;
    }

    try{
        const response = await axios.get(`${baseURL}/auth-key`, {
            headers: { "Content-Type": "application/json" }
        });
        
        if(response?.data?.success && response?.data?.data?.auth_key !== null){

            const newToken = response?.data?.data?.auth_key;
            localStorage.setItem("sessionToken", newToken);
            return;
        }else{
            throw new Error("No Token from server");            
        }
    }
    catch(error){
        console.log("Authentication Error :",error);
        throw error;
    }   
}